import React from 'react';

import OneHourAfterJapanBroadcast from 'app/features/pricingPromo/landing/components/megaFanPerks/perks/components/OneHourAfterJapanBroadcast';
import AdFreeAnime from 'app/features/pricingPromo/landing/components/megaFanPerks/perks/components/AdFreeAnime';
import OfflineViewing from 'app/features/pricingPromo/landing/components/megaFanPerks/perks/components/OfflineViewing';
import StreamOnMultipleDevices from 'app/features/pricingPromo/landing/components/megaFanPerks/perks/components/StreamOnMultipleDevices';
import { Styled } from 'app/features/pricingPromo/landing/components/megaFanPerks/perks/components/Perks.styled';

const Perks = () => (
  <Styled.Perks data-t="perks-section">
    <OneHourAfterJapanBroadcast />
    <AdFreeAnime />
    <OfflineViewing />
    <StreamOnMultipleDevices />
  </Styled.Perks>
);

Perks.displayName = 'Perks';

export default Perks;
